<template>
    <div class="stf-info-text">
        <slot />
    </div>
</template>

<script setup lang="ts">
</script>

<style lang="scss">
@use '@/assets/sass/_variables' as vars;
@use "bulma/sass/utilities/mixins";

.stf-info-text {
  font-family: vars.$font-family-primary;
  font-weight: vars.$font-weight-normal;
  font-size: vars.$font-size-17;
  letter-spacing: 0;
  color: #414141;

  @include mixins.mobile {
    font-size: vars.$font-size-13;
  }
}
</style>
